import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-warning text-dark",
  role: "alert"
}

import { computed, toRef } from 'vue'

    import AlternativesViewDependenciesList from '@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesList.vue'
    import type { AlternativesViewDependenciesDialogViewModel } from '@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesDialog'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AlternativesViewDependenciesDialog',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value?.initialized ?? false)

    const name = computed(() => vm.value.name)
    const dependenciesCount = computed(() => vm.value.dependenciesCount)

    const reports = computed(() => vm.value.reports)
    const lists = computed(() => vm.value.lists)
    const estimationsSurveys = computed(() => vm.value.estimationsSurveys)

    // ---------------- methods ----------------s ----------------

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "List dependencies", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", null, [
                        _cache[1] || (_cache[1] = _createTextVNode("The list '", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(name.value), 1 /* TEXT */),
                        _cache[2] || (_cache[2] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(dependenciesCount.value), 1 /* TEXT */),
                        _cache[3] || (_cache[3] = _createTextVNode(" places.", -1 /* CACHED */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(AlternativesViewDependenciesList, {
                  initialized: initialized.value,
                  reports: reports.value,
                  lists: lists.value,
                  estimationsSurveys: estimationsSurveys.value
                }, null, 8 /* PROPS */, ["initialized", "reports", "lists", "estimationsSurveys"])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})